import { ONE_SECOND } from '@lucidlink/uicore';
const isPageHidden = () => document.visibilityState === 'hidden';
export const trackPageActivity = () => {
    let wasOffline = !navigator.onLine;
    let hiddenDuration = 0;
    let hiddenSince = isPageHidden() ? Date.now() : null;
    const onOffline = () => {
        wasOffline = true;
    };
    const onVisibilityChange = () => {
        if (isPageHidden()) {
            hiddenSince ??= Date.now();
            return;
        }
        if (hiddenSince !== null) {
            hiddenDuration += Date.now() - hiddenSince;
            hiddenSince = null;
        }
    };
    window.addEventListener('offline', onOffline);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return {
        hiddenDurationSeconds: () => (hiddenDuration +
            (hiddenSince === null ? 0 : Date.now() - hiddenSince)) /
            ONE_SECOND,
        stop: () => {
            window.removeEventListener('offline', onOffline);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        },
        wasOffline: () => wasOffline,
    };
};
